import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ZajmijMiejsceWFotelu() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="32734" id="zacznij-oszczędzać-na-ogrzewaniu" className="dark bg-secondary text-secondary-foreground relative min-h-[600px] w-full overflow-hidden flex items-center justify-center py-24 border-y-4 border-primary">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-secondary/75 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606250/img/heating_pipes_clean.png)] bg-cover bg-center bg-no-repeat opacity-40" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(11,17,32,0.9)_100%)] z-20" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-30 container mx-auto px-4 text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="font-sans text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter text-white mb-12 drop-shadow-2xl uppercase">
          Zacznij Oszczędzać Na Ogrzewaniu.
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg px-10 py-7 h-auto font-sans font-extrabold tracking-tight uppercase rounded-xl border-2 border-primary shadow-xl shadow-primary/30">
            <Link to="/ContactPage">Zadzwoń Teraz</Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="bg-transparent border-2 border-primary text-primary hover:bg-primary/10 hover:text-primary hover:border-primary text-lg px-10 py-7 h-auto font-sans font-extrabold tracking-tight uppercase rounded-xl backdrop-blur-md">
            <Link to="/ContactPage">Napisz Do Nas</Link>
          </Button>
        </div>
      </div>
    </section>;
}